import React from "react";
import { useNavigate } from "react-router-dom";

const withNavigate = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const ComponentWithNavigate = (props: P) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  };

  return ComponentWithNavigate;
};

export default withNavigate;
